import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { AcModel } from 'projects/runner/src/app/models/ac.model';
import { CandidateModel } from 'projects/runner/src/app/models/candidate.model';
import { ApiService } from 'projects/runner/src/app/services/api.service';
import { DataService } from 'projects/runner/src/app/services/data.service';
import { UiService } from 'projects/runner/src/app/services/ui.service';

@Component({
  selector: 'app-ac-move-selector',
  templateUrl: './ac-move-selector.component.html',
  styleUrls: ['./ac-move-selector.component.scss']
})
export class AcMoveSelectorComponent implements OnInit {

  @Input() candidate: CandidateModel = null;
  @Output('cancelled') cancelled = new EventEmitter<void>();
  @Output('moved') moved = new EventEmitter<void>();

  public acs: Array<AcModel> = [];
  public selected: AcModel = null;
  public moveable = false;
  public loading = true;
  public submitting = false;

  constructor(
    private api: ApiService,
    private ui: UiService,
    private data: DataService,
    private transloco: TranslocoService
  ) { }

  ngOnInit(): void {
    this.api.getMovingAcs().subscribe({
      next: (result: any) => {
        this.acs = result.data.map((ac: any) => {
          return new AcModel().deserialize(ac);
        });
      },
      error: () => {
      }
    }).add(() => {
      this.loading = false;
    });
  }

  public selectAc(selected: AcModel): void {
    if (this.selected === selected) {
      this.selected = null;
    } else {
      this.selected = selected;
    }
  }

  public onCancel(): void {
    this.cancelled.emit();
  }

  public onMove(): void {
    if (this.selected !== null, this.candidate !== null) {
      this.submitting = true;
      this.api.moveCandidateToOtherAc(this.selected.id, this.candidate.hashed_id).subscribe({
        next: (result: any) => {
          const ac = this.data.ac.deserialize(result.data);
          ac.mapAcStatus(true);
          this.data.setAc(ac);
          this.moved.emit();
        },
        error: () => {
          this.ui.toastError(this.transloco.translate('dashboard.misc.moving_error'));
        }
      }).add(() => {
        this.submitting = false;
      });
    }
  }

}
